import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/main'
import home from '@/views/home'
import programme from '@/views/programme'
import technology from '@/views/technology'
import headlines from '@/views/headlines'
import summit from '@/views/summit'
import divinemap from '@/views/divinemap'
import about from '@/views/about'
import articleInfo from '@/views/articleInfo'
import futures from '@/views/futures'
import caseInfo from '@/views/case'
import appInfo from '@/views/app'
import expert from '@/views/expert'
import metting from '@/views/metting'
import CloudSaaS1 from '@/views/jtjc/CloudSaaS1'
import CloudSaaS2 from '@/views/jtjc/CloudSaaS2'
import CloudSaaS3 from '@/views/jtjc/CloudSaaS3'
import CloudSaaS4 from '@/views/jtjc/CloudSaaS4'
import CloudSaaS5 from '@/views/jtjc/CloudSaaS5'
import websiteDirectory from '@/views/websiteDirectory'
import profile from '@/views/profile'
import changePassword from '@/views/changePassword'
import favorites from '@/views/favorites'
import orders from '@/views/orders'
import trial from '@/views/trial'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      redirect: '/'
    },
    {
      path: '/',
      name: 'layout',
      component: layout,
      meta: {
        title: '首页'
      },
      redirect: {
        name: 'home'
      },
      children: [
        {
          path: '/home',
          name: 'home',
          component: home,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/futures',
          name: 'futures',
          component: futures,
          meta: {
            title: '大宗期货'
          }
        },
        {
          path: '/case',
          name: 'case',
          component: caseInfo,
          meta: {
            title: '热门场景'
          }
        },
        {
          path: '/app',
          name: 'app',
          component: appInfo,
          meta: {
            title: '软件超市'
          }
        },
        {
          path: '/expert',
          name: 'expert',
          component: expert,
          meta: {
            title: '专家'
          }
        },
        {
          path: '/metting',
          name: 'metting',
          component: metting,
          meta: {
            title: '峰会-移动端'
          }
        },
        {
          path: '/programme',
          name: 'programme',
          component: programme,
          meta: {
            title: '方案'
          }
        },
        {
          path: '/technology',
          name: 'technology',
          component: technology,
          meta: {
            title: '科技'
          }
        },
        {
          path: '/headlines',
          name: 'headlines',
          component: headlines,
          meta: {
            title: '头条'
          }
        },
        {
          path: '/summit',
          name: 'summit',
          component: summit,
          meta: {
            title: '峰会'
          }
        },
        {
          path: '/divinemap',
          name: 'divinemap',
          component: divinemap,
          meta: {
            title: '神图'
          }
        },
        {
          path: '/about',
          name: 'about',
          component: about,
          meta: {
            title: '关于'
          }
        },
        {
          path: '/articleInfo',
          name: 'articleInfo',
          component: articleInfo,
          meta: {
            title: '文章详情'
          }
        },
        {
          path: '/cloudSaaS1',
          name: 'cloudSaaS1',
          component: CloudSaaS1,
          meta: {
            title: 'SCM供应链管理系统'
          }
        },
        {
          path: '/cloudSaaS2',
          name: 'cloudSaaS2',
          component: CloudSaaS2,
          meta: {
            title: 'B2B电商交易系统'
          }
        },
        {
          path: '/cloudSaaS3',
          name: 'cloudSaaS3',
          component: CloudSaaS3,
          meta: {
            title: '数字化采购管理系统'
          }
        },
        {
          path: '/cloudSaaS4',
          name: 'cloudSaaS4',
          component: CloudSaaS4,
          meta: {
            title: '智慧风控系统'
          }
        },
        {
          path: '/cloudSaaS5',
          name: 'cloudSaaS5',
          component: CloudSaaS5,
          meta: {
            title: '数据中台系统'
          }
        },
        {
          path: '/websiteDirectory',
          name: 'websiteDirectory',
          component: websiteDirectory,
          meta: {
            title: '供应链网址'
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: profile,
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/change-password',
          name: 'changePassword',
          component: changePassword,
          meta: {
            title: '修改密码'
          }
        },
        {
          path: '/favorites',
          name: 'favorites',
          component: favorites,
          meta: {
            title: '我的收藏'
          }
        },
        {
          path: '/orders',
          name: 'orders',
          component: orders,
          meta: {
            title: '我的订单'
          }
        },
        {
          path: '/trial',
          name: 'trial',
          component: trial,
          meta: {
            title: '试用申请'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js